function escapeIdent(value: string): string {
  if (typeof CSS !== "undefined" && typeof CSS.escape === "function") return CSS.escape(value);
  return value.replace(/([^\w-])/g, "\\$1");
}

/**
 * Build a CSS selector that resolves back to `el`.
 * Prefers an id (the element's own, or the nearest ancestor's as an anchor),
 * otherwise a structural `tag:nth-of-type(n)` path up to the document root.
 */
export function cssSelector(el: Element): string {
  if (el.id) return `#${escapeIdent(el.id)}`;

  const parts: string[] = [];
  let node: Element | null = el;

  while (node && node.nodeType === 1 && node !== document.documentElement) {
    const current: Element = node;
    if (current.id) {
      parts.unshift(`#${escapeIdent(current.id)}`);
      return parts.join(" > ");
    }

    let part = current.tagName.toLowerCase();
    const parent = current.parentElement;
    if (parent) {
      const sameTag = Array.from(parent.children).filter((c) => c.tagName === current.tagName);
      if (sameTag.length > 1) part += `:nth-of-type(${sameTag.indexOf(current) + 1})`;
    }
    parts.unshift(part);
    node = parent;
  }

  return parts.join(" > ");
}
